var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_279_721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9351 6H19.4676C19.4676 6 26.5743 18.8663 22.8119 28.4633C24.3795 25.6158 34.9351 6 34.9351 6Z",
    fill: "url(#paint0_linear_279_721)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8855 34.0528H35.353C35.353 34.0528 28.2463 21.1865 32.0087 11.5895C30.5456 14.437 19.8855 34.0528 19.8855 34.0528Z",
    fill: "url(#paint1_linear_279_721)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4675 6H4C4 6 11.1067 18.8663 7.34433 28.4633C8.80747 25.6158 19.4675 6 19.4675 6Z",
    fill: "url(#paint2_linear_279_721)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.418 34.294H19.8855C19.8855 34.294 12.7788 21.4277 16.5412 11.8307C15.078 14.6781 4.418 34.294 4.418 34.294Z",
    fill: "url(#paint3_linear_279_721)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_279_721",
    x1: 27.2013,
    y1: 6,
    x2: 27.2013,
    y2: 28.4633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#135C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#699391",
    stopOpacity: 0.87
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_279_721",
    x1: 27.6193,
    y1: 11.5895,
    x2: 27.6193,
    y2: 34.0528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#135C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#699391",
    stopOpacity: 0.87
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_279_721",
    x1: 11.7338,
    y1: 6,
    x2: 11.7338,
    y2: 28.4633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#135C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#699391",
    stopOpacity: 0.87
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_279_721",
    x1: 12.1518,
    y1: 11.8307,
    x2: 12.1518,
    y2: 34.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#135C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#699391",
    stopOpacity: 0.87
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_279_721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.3531,
    height: 28.0528,
    fill: "white",
    transform: "translate(4 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.78d8e07cb455fe3e9ccb35f88746fb32.svg";
export { ForwardRef as ReactComponent };